/* eslint-disable @typescript-eslint/no-unused-vars */
const rows = [
  {
    id: 1,
    type: 'produto',
    name: 'Lorem Ipsum..',
    category: 'Lorem Ipsum.',
    tax: 2.2,
    product: 'Lorem Ipsum.',
  },
];

const tableHeader = [
  'Imagem',
  'SKU',
  'Nome',
  'Categoria',
  'Preço Base',
  'Preço Consumo',
  'Preço Revenda',
  'IPI',
  'Imposto',
  'Frete',
  'Margin',
  'Altura',
  'Largura',
  'Profundidade',
  'NCM',
  'Editar',
  'Excluir',
  'Duplicar',
];

const Tablecadastro = [
  {
    id: 'nome',
    title: 'Nome',
    type: 'text',
    placeholder: 'Informe o nome do produto ...',
  },
  {
    id: 'categoria',
    title: 'Categoria',
    type: 'select',
    placeholder: 'Informe a categoria ...',
  },
  {
    id: 'precoBase',
    title: 'Preço Base',
    type: 'number',
    placeholder: 'Preço Base ...',
  },
  {
    id: 'precoConsumo',
    title: 'Preço Consumo',
    type: 'number',
    placeholder: 'Preço Consumo ...',
  },
  {
    id: 'precoRevenda',
    title: 'Preço Revenda',
    type: 'number',
    placeholder: 'Preço Revenda ...',
  },
  { id: 'ipi', title: 'IPI', type: 'number', placeholder: 'Valor do IPI em % ...' },
  {
    id: 'imposto',
    title: 'Imposto',
    type: 'number',
    placeholder: 'Valor do imposto em %...',
  },

  { id: 'frete', title: 'Frete', type: 'number', placeholder: 'Valor do frete em % ...' },
  { id: 'margin', title: 'Margin', type: 'number', placeholder: 'Valor da margin em % ...' },
  {
    id: 'altura',
    title: 'Altura em mm',
    type: 'number',
    placeholder: 'Alutra em mm ...',
  },
  {
    id: 'largura',
    title: 'Largura em mm',
    type: 'number',
    placeholder: 'Largura em mm...',
  },
  {
    id: 'profundidade',
    title: 'Profundidade em mm',
    type: 'number',
    placeholder: 'Profundidade em mm...',
  },
  { id: 'SKU', title: 'SKU', type: 'text', placeholder: 'SKU ...' },
  { id: 'NCM', title: 'NCM', type: 'text', placeholder: 'NCM ...' },
  {
    id: 'isActive',
    title: 'Ativo',
    type: 'checkbox',
    placeholder: 'Produto ativo',
  },

  {
    id: 'arrCaracteristica',
    content: [
      {
        id: 'cores',
        title: 'Cor Hexadecimal',
        type: 'select',
        multiple: 'multiple',
        placeholder: 'Selecione a cor',
      },
      {
        id: 'image',
        title: 'Imagem do Produto',
        type: 'file',
        placeholder: 'Selecione a imagem',
      },
    ],
  },
];

const title = 'Cadastro de Produto';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'produto',
};
